// Tab "Export": PPM en callsheet (.pptx), volledige breakdown (.xlsx) en Universal Schedule Standard.
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, TextField, Typography } from '@mui/material';
import { meldFout } from '../../../utils/apiFout';
import { bestandExport, downloadBlob, exportJson, wijzigProductie, INKT, STIL } from '../breakdownApi';
import { Kaart, Kop, Rij, Secundair } from '../onderdelen';

const EXPORTS = [
  { id: 'ppm', pad: 'ppm.pptx', naam: 'PPM', uitleg: 'Titelpagina, deliverables, shotlist, cast, locaties, props en planning — met de gekozen opties.', bestand: 'PPM.pptx' },
  { id: 'callsheet', pad: 'callsheet.pptx', naam: 'Callsheet', uitleg: 'Call-tijd en -plek, weer, noodinfo, crew met call-tijden en cast.', bestand: 'Callsheet.pptx' },
  { id: 'xlsx', pad: 'breakdown.xlsx', naam: 'Volledige breakdown', uitleg: 'Alle items, scenes, shots, crew, materiaal en planning in één Excel-bestand.', bestand: 'Breakdown.xlsx' },
  { id: 'uss', json: 'uss', naam: 'Universal Schedule Standard', uitleg: 'JSON voor planningssoftware die USS leest (best effort).', bestand: 'USS.json' },
];

export default function ExportsTab({ productie, onProductie }) {
  const [deliverables, setDeliverables] = useState(productie.deliverables || '');
  const [bezig, setBezig] = useState(null);
  useEffect(() => { setDeliverables(productie.deliverables || ''); }, [productie.deliverables]);

  async function bewaarDeliverables() {
    if (deliverables === (productie.deliverables || '')) return;
    try { onProductie(await wijzigProductie(productie.id, { deliverables })); }
    catch (e) { meldFout(e, 'Deliverables opslaan'); }
  }

  async function download(x) {
    setBezig(x.id);
    try {
      if (x.json) {
        const data = await exportJson(productie.id, x.json);
        downloadBlob(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }), `${x.naam} - ${productie.name}.json`);
      } else {
        await bestandExport(productie.id, x.pad, `${x.bestand}`);
      }
    } catch (e) { meldFout(e, 'Export'); }
    finally { setBezig(null); }
  }

  return (
    <Box>
      <Kop>Deliverables</Kop>
      <TextField fullWidth multiline minRows={3} size="small" placeholder={'Eén per regel, bv.\nTVC 30s 16:9\nCut-down 15s 9:16'}
        value={deliverables} onChange={(e) => setDeliverables(e.target.value)} onBlur={bewaarDeliverables}
        helperText="Komen op de PPM. Slaat op zodra je het veld verlaat." sx={{ mb: 2.5 }} />
      <Kop>Downloaden</Kop>
      <Kaart>
        {EXPORTS.map((x) => (
          <Rij key={x.id}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: INKT }}>{x.naam}</Typography>
              <Typography sx={{ fontSize: 12.5, color: STIL }}>{x.uitleg}</Typography>
            </Box>
            <Secundair onClick={() => download(x)} disabled={!!bezig} startIcon={bezig === x.id ? <CircularProgress size={12} /> : null}>
              {x.bestand.split('.').pop().toUpperCase()}
            </Secundair>
          </Rij>
        ))}
      </Kaart>
      <Typography sx={{ mt: 1.5, fontSize: 12.5, color: STIL }}>Uitwisselen met Cadre (storyboard) kan in het tabblad Shotlist.</Typography>
    </Box>
  );
}
